export var Order;
(function (Order) {
    Order["ASC"] = "asc";
    Order["DESC"] = "desc";
    Order["DEFAULT"] = "default";
})(Order || (Order = {}));
export var DataType;
(function (DataType) {
    DataType[DataType["STRING"] = 0] = "STRING";
    DataType[DataType["NUMBER"] = 1] = "NUMBER";
})(DataType || (DataType = {}));
//# sourceMappingURL=oh-table.types.js.map
